// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"5a8e3dd02db1ca27","836":"322c4bd0e45d10a5"}[chunkId] + ".js";
};